/**
 * Home container.
 * @module components/theme/ConnectionRefused/ConnectionRefused
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Container } from 'semantic-ui-react';

const ConnectionRefused = () => (
  <Container className="view-wrapper error-page">
    <h3>
      <FormattedMessage
        id="Connection refused"
        defaultMessage="Connection refused"
      />
    </h3>
    <p style={{ textAlign: 'center' }}>
      <FormattedMessage
        id="The connection to the server was refused. Please try again later"
        defaultMessage="The connection to the server was refused. Please try again later."
      />
    </p>
  </Container>
);

export default ConnectionRefused;
